import React, { useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { enUS } from 'date-fns/locale';

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const ReportPeriodFilter = ({ value, onChange }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [range, setRange] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);

  return <div className="relative flex items-center gap-2">
    <label className="text-sm font-medium text-gray-700">Period</label>
    <select value={value.includes(':') ? 'custom' : value} onClick={(event) => event.target.value === 'custom' && setShowCalendar(true)} onChange={(event) => {
      if (event.target.value === 'custom') setShowCalendar(true);
      else { setShowCalendar(false); onChange(event.target.value); }
    }} className="border border-gray-300 rounded px-3 py-2 text-sm bg-white">
      <option value="thisWeek">This Week</option><option value="lastWeek">Last Week</option><option value="thisMonth">This Month</option><option value="lastMonth">Last Month</option><option value="custom">Custom</option>
    </select>
    {showCalendar && <div className="absolute right-0 top-full mt-2 z-[90] bg-white border rounded-lg shadow-xl p-3">
      <DateRange editableDateInputs onChange={(item) => setRange([item.selection])} moveRangeOnFirstSelection={false} ranges={range} rangeColors={["#2563eb"]} months={1} direction="horizontal" locale={enUS} />
      <div className="flex justify-end gap-2 mt-2"><button onClick={() => setShowCalendar(false)} className="px-3 py-1.5 border rounded">Cancel</button><button onClick={() => { onChange(`${formatDate(range[0].startDate)}:${formatDate(range[0].endDate)}`); setShowCalendar(false); }} className="px-3 py-1.5 bg-blue-600 text-white rounded">Apply</button></div>
    </div>}
  </div>;
};

export default ReportPeriodFilter;
